__turbopack_context__.v({
  "animalWelfare": "wDP9-G_animalWelfare",
  "futureGenerations": "wDP9-G_futureGenerations",
  "globalHealth": "wDP9-G_globalHealth",
  "icon": "wDP9-G_icon",
  "multiple": "wDP9-G_multiple",
  "operations": "wDP9-G_operations",
  "other": "wDP9-G_other",
});
